import * as React from 'react';

import DegreeHomeApp from 'bundles/degree-home/components/DegreeHomeApp';
import useDegreeDataAndPermission from 'bundles/degree-home/utils/useDegreeDataAndPermission';

const DegreeHomeAppV1Container: React.FC = ({ children }) => {
  const { location, userId, degreeSlug, degreeMetadata, membershipStatus, partners, degreeLoading } =
    useDegreeDataAndPermission();

  if (membershipStatus === 'data_loading' || degreeLoading) {
    return null;
  }

  return (
    <DegreeHomeApp
      location={location}
      userId={userId}
      degreeSlug={degreeSlug}
      degreeMetadata={degreeMetadata}
      membershipStatus={membershipStatus}
      partners={partners}
    >
      {children}
    </DegreeHomeApp>
  );
};

export default DegreeHomeAppV1Container;
